import {
  ADDPRODUCTTOCART,
  REMOVEPRODUCTTOCART,
  HANDLECARTITEMQUENTITY,
} from "./actionType";
import initalState from "./initialState";

const cartItemsReducer = (state = initalState, action) => {
  switch (action.type) {
    case ADDPRODUCTTOCART:
      return [
        ...state,
        {
          ...action.payload,
          quantity: 1,
        },
      ];

    case REMOVEPRODUCTTOCART:
      return state.filter((product) => product?.id !== action.payload);

    case HANDLECARTITEMQUENTITY:
      const { id, oparationType } = action.payload;

      switch (oparationType) {
        case "plus":
          return state.map((product) => {
            if (product?.id === id) {
              return {
                ...product,
                quantity: Number(product?.quantity) + 1,
              };
            }
            return product;
          });

        case "minus":
          return state.map((product) => {
            if (product?.id === id) {
              return {
                ...product,
                quantity: Number(product?.quantity) - 1,
              };
            }
            return product;
          });

        default:
          return state;
      }

    default:
      return state;
  }
};

export default cartItemsReducer;
